import React from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";

Breadcrumb.propTypes = {
  breadcrumbName: PropTypes.string,
  category: PropTypes.string,
};

function Breadcrumb({ category, breadcrumbName }) {
  const { t } = useTranslation();
  return (
    <div className="container">
      <p id="breadcrumbs">
        <a href="https://www.okayama-kanko.jp/">HOME</a>
        <span><FontAwesomeIcon icon={faChevronRight} /></span>
        <a href="/experience/txj">{category && category == 1 ? "体験・ツアー" : category == 2 ? "グルメ" : t('search')}</a>
        {category && (
          <>
            <span><FontAwesomeIcon icon={faChevronRight} /></span>
            <a href={`?category=${category}`}>{breadcrumbName}</a>
          </>
        )}
      </p>
    </div>
  );
}

export default Breadcrumb;
